var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"py-0"},[_c('v-text-field',{attrs:{"outlined":"","filled":"","label":"Text jawaban singkat","hide-details":"auto"},model:{value:(_vm.correct),callback:function ($$v) {_vm.correct=$$v},expression:"correct"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }